// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"a4c0d3c7","787":"f610bc6f"}[chunkId] + ".chunk.js";
};